'use client';
import { useI18n as useTranslatedText } from '@/i18n/i18n';
export default function ErrorPage({ reset }: { reset: () => void }) {
  const { t: tr } = useTranslatedText();

  return (
    <section className="container">
      <h1>{tr('Не удалось открыть страницу')}</h1>
      <p>{tr('Проверьте соединение и повторите попытку.')}</p>
      <button onClick={reset}>{tr('Повторить')}</button>
    </section>
  );
}
